import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallChip } from '../../components/chips/SmallChip';

type Props = {
  count: number;
};

export const CommentaryCountChip: FC<Props> = ({ count }) => {
  return (
    <SmallChip color="secondary">
      <FormattedMessage id="CommentaryCountChip" values={{ count }} />
    </SmallChip>
  );
};
